module.exports = __webpack_public_path__ + "img/Full_logo-Black.e009f17e.svg";